<template>
  <v-dialog v-model="value" @click:outside="onClickOutside">
    <popup-layout @close="close">
      <div class="popup-container">
        <div class="content-section">
          <h4 class="popup-title">Distribution</h4>
          <template v-if="items && items.length > 0">
            <perfect-scrollbar class="ps">
              <div class="popup-items-list">
                <PopupItem
                  v-for="(item, index) of items"
                  :key="index"
                  :item="item"
                  @click="onClickItem"
                />
              </div>
              <pagination
                :length="totalPages"
                @change="onPageChange"
                :color="color"
              />
            </perfect-scrollbar>
          </template>
          <template v-else>
            <div class="no-results">No results.</div>
          </template>
        </div>
        <div class="filters-section">
          <Filters ref="filters" @search="onSearch" />
        </div>
      </div>
    </popup-layout>
  </v-dialog>
</template>

<script>
import PopupItem from "./PopupItem";
import Filters from "./Filters";
import { merge } from "lodash";
import PopupLayout from "../../layouts/PopupLayout.vue";
import Pagination from "../Pagination.vue";

export default {
  components: {
    PopupItem,
    Filters,
    PopupLayout,
    Pagination,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contentId: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 4,
    },
    color: {
      type: String,
      default: null,
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.reset();
        this.load();
      }
    },
  },
  data() {
    return {
      show: false,
      filters: null,
      items: [],
      page: 1,
      totalPages: 0,
    };
  },
  mounted() {
    if (this.value) {
      this.load();
    }
  },
  methods: {
    reset() {
      this.items = [];
      this.page = 1;
      this.totalPages = 0;
      this.filters = null;
    },
    async load() {
      let args = {
        contentId: this.contentId,
        page: this.page,
        limit: this.limit,
      };

      if (this.filters) {
        args = merge(args, this.filters);
      }

      const {
        results,
        totalPages,
      } = await this.$repo.platform.getJoinablePlatforms(args);
      this.items = results;
      this.totalPages = totalPages;
    },
    close() {
      this.reset();
      this.$refs.filters.reset();
      this.$emit("input", false);
      this.$emit("close");
    },
    onClickOutside() {
      this.close();
    },
    onClickItem(item) {
      this.$emit("select", item);
      this.close();
    },
    onSearch(filters) {
      this.reset();
      this.filters = merge({}, filters);
      this.load();
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-container {
  .popup-title {
    color: var(--color-blue-sky);
    margin: 0 0 20px;
  }

  .popup-items-list {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 1fr;
    column-gap: 25px;
    row-gap: 25px;
  }

  .no-results {
    text-align: center;
    margin-top: 100px;
    font-size: 1.25rem;
    font-weight: normal;
  }

  @media screen and (min-width: $breakpoint-tablet) {
    display: flex;

    .popup-items-list {
      grid-template-columns: repeat(2, 1fr);
    }

    .content-section {
      flex: 1 1 auto;
      margin-right: 40px;
    }

    .filters-section {
      width: 340px;
    }
  }
}
</style>